import defaultStorePlugin from 'store/plugins/defaults';
import expirePlugin from 'store/plugins/expire';
import storeEngine from 'store/src/store-engine';
import memoryStorage from 'store/storages/memoryStorage';
import sessionStorage from 'store/storages/sessionStorage';
import { plugins } from '../../utils.tsx';

export const makeSessionStore = () =>
	storeEngine.createStore([sessionStorage, memoryStorage], plugins);

export const makeSessionExpirableStore = () =>
	storeEngine.createStore([sessionStorage, memoryStorage], [defaultStorePlugin, expirePlugin]);
